import { render, staticRenderFns } from "./DeleteUserLog.vue?vue&type=template&id=57d7ce4c&lang=pug&"
import script from "./DeleteUserLog.vue?vue&type=script&lang=ts&"
export * from "./DeleteUserLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports